import { render, staticRenderFns } from "./DetailsModals.vue?vue&type=template&id=35271466&scoped=true&lang=pug&"
import script from "./DetailsModals.vue?vue&type=script&lang=ts&"
export * from "./DetailsModals.vue?vue&type=script&lang=ts&"
import style0 from "./DetailsModals.vue?vue&type=style&index=0&id=35271466&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35271466",
  null
  
)

export default component.exports